/**
 * Shared amendments-domain constants. See docs/amendments-tab-drilling.md
 * for the design rationale (reference scheme §4, status enum and category
 * enum §5).
 */

// 31-char alphabet — uppercase A–Z + digits 0–9, excluding visually
// ambiguous characters (0/O, 1/I/L). Locked in §4 of the drilling doc.
export const AMENDMENT_REFERENCE_ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789"
export const AMENDMENT_REFERENCE_LENGTH = 8
export const AMENDMENT_REFERENCE_PREFIX = "GHDA-"

export const AMENDMENT_CATEGORIES = {
	group_size: "Group size",
	dates: "Dates",
	rooming: "Rooming",
	names: "Names",
	tee_times: "Tee times",
	other: "Other",
}

export const AMENDMENT_STATUSES = {
	open: "Open",
	closed: "Closed",
	cancelled: "Cancelled",
}
